export default __webpack_public_path__ + "static/media/Keplr1.bfaf4e93.svg";